import Prismic from 'prismic-javascript'
import { Document } from 'prismic-javascript/types/documents'
import { PRISMIC_KEY, PRISMIC_PATH } from './config'

export type PrismicDocument = Document
export const PrismicClient = Prismic.client(PRISMIC_PATH, { accessToken: PRISMIC_KEY })
